import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  constructor(private configService: ConfigService) {}

  /**
   * 获取当前环境
   * dev/qas/prd
   */
  public get environment() {
    let environment = this.configService.getSettings('environment', 'dev');
    return environment;
  }

  /**
   * 获取config
   * @param key 键
   */
  public getConfig(key: string): string {
    return this.configService.getSettings(this.produceConfigKey(key), '');
  }

  /**
   * 获取实际键值
   * @param key 键
   */
  public getActualConfig(key: string): any {
    return this.configService.getSettings(key, '');
  }

  /**
   * 生成Config的地址
   * @param key 键
   */
  private produceConfigKey(key: string): string {
    return 'config.' + this.environment + '.' + key;
  }
}
